import type { LucideIcon } from "lucide-react";
import { CircleDashed } from "lucide-react";
import { IconAction } from "@/ds/IconAction";
import { type Phase, phases } from "../registry";

const phasesMap: Record<number, { label: string; icon: LucideIcon }> =
  Object.fromEntries(phases.map((el) => [el.id, el]));

const defaultPhase = { label: "Ready for Writing", icon: CircleDashed };

export function AudioBookPhase({ phase }: { phase?: Phase | null }) {
  const { label, icon } = (phase != null && phasesMap[phase]) || defaultPhase;

  // A focusable control so the tooltip is reachable without a pointer, and named
  // so the phase is available without opening it at all. The label is too long
  // to show inline on a card, which is why it stays a tooltip.
  return (
    <IconAction
      label={`Phase: ${label}`}
      icon={icon}
      variant="ghost"
      size="icon-xs"
      className="shrink-0 text-muted-foreground"
    />
  );
}
